export const technologiesArray = [
  { name: "vue", url: "https://vuejs.org/" },
  { name: "ember", url: "https://emberjs.com/" },
  {
    name: "js",
    url: "https://developer.mozilla.org/en-US/docs/Web/JavaScript"
  },
  { name: "node", url: "https://nodejs.org/en/" },
  { name: "ruby", url: "https://rubyonrails.org/" },
  { name: "sql", url: "https://www.mysql.com/" },
  { name: "mongo", url: "https://www.mongodb.com/" },
  { name: "sass", url: "https://sass-lang.com/" },
  { name: "bulma", url: "https://bulma.io/" },
  { name: "tailwind", url: "https://tailwindcss.com/" },
  { name: "sketch", url: "https://www.sketch.com/" },
  { name: "balsamiq", url: "https://balsamiq.com/" }
]